export default class UnknownPeakJson {
    #rtMinutes
    #startMinutes
    #endMinutes
    #base;
    #area;
    #areaPerc;

    /**
     * @param {number} rtMinutes
     * @param {number} startMinutes
     * @param {number} endMinutes
     * @param {number} base
     * @param {number} area
     * @param {number} areaPerc
     */
    constructor(startMinutes, rtMinutes, endMinutes, base, area, areaPerc) {
        this.#rtMinutes = rtMinutes;
        this.#startMinutes = startMinutes;
        this.#endMinutes = endMinutes;
        this.#base = base;
        this.#area = area;
        this.#areaPerc = areaPerc;
    }

    /** @return {number} */
    get startMinutes() {
        return this.#startMinutes;
    }

    /** @return {number} */
    get endMinutes() {
        return this.#endMinutes;
    }

    /** @return {number} */
    get rtMinutes() {
        return this.#rtMinutes;
    }

    /** @return {number|null} */
    get base() {
        return this.#base === 0 ? null : this.#base;
    }

    /** @return {number} */
    get area() {
        return this.#area;
    }

    /** @return {number} */
    get areaPerc() {
        return this.#areaPerc;
    }

    /**
     * @param {UnknownPeakJson} other
     * @return {boolean}
     */
    equals(other) {
        return other instanceof UnknownPeakJson && this.rtMinutes === other.rtMinutes;
    }

    /** @return {UnknownPeakJson[]} */
    static parseManyFromServerBytes(base64String) {
        if (typeof base64String !== "string" || base64String.length === 0) {
            return [];
        }
        const data = new DataView(Int8Array.from(atob(base64String), c => c.charCodeAt(0)).buffer)
        const unknownPeaks = [];
        const ver = data.getInt8(0);
        if (ver !== 1)
            throw new Error(`Can't read unknown peaks, version is not supported: ${ver}`);
        const end = data.byteLength;
        const step = 24;
        for (let i = 1; i < end; i += step) {
            unknownPeaks.push(new UnknownPeakJson(
                +data.getFloat32(i).toFixed(6),
                +data.getFloat32(i + 4).toFixed(6),
                +data.getFloat32(i + 8).toFixed(6),
                +data.getFloat32(i + 12).toFixed(6),
                +data.getFloat32(i + 16).toFixed(6),
                +data.getFloat32(i + 20).toFixed(6),
            ));
        }
        return unknownPeaks;
    }
}